import { StateSchema } from 'app/config/storeConfig/types';
import { User } from '../types';

export const getLoggedUserData = (state: StateSchema): Nullable<User> => state.user.userData;
